<template>
  <div class="index">
    <h2 class="settings-title">Settings: {{ routeName }}</h2>

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'SettingsIndex',

  computed: {
    routeName () {
      return this.$route.meta.title
    }
  }
}
</script>

<style lang="scss">
.settings-title {
  margin: 1rem auto 2rem;
  text-align: center;
}
</style>
